import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const fourYearOldTantrums: BlogMetaData = {
  title: '4歳の癇癪がひどい理由と対処法7選｜モンテッソーリ流・秩序の敏感期を活かした感情サポート',
  description:
    '4歳になって突然癇癪がひどくなった…と悩む保護者へ。前頭前野の発達・秩序の敏感期・自己表現欲求という3つの原因を整理し、今日から実践できる対処法7選とモンテッソーリ視点の環境設計でお子さまの感情コントロール力を育てる方法を解説します。',
  thumbnailUrl: '/img/blog-4-year-old-tantrums.png',
  filePath: buildBlogFilePath('4-year-old-tantrums'),
  category: BLOG_CATEGORY.PARENTING,
};
